interface LoadingIndicatorProps {
  text?: string;
}

export default function LoadingIndicator({
  text = 'Thinking',
}: LoadingIndicatorProps) {
  return (
    <div className="loading-indicator" role="status" aria-label="Loading">
      <span className="loading-text">{text}</span>
      <span className="loading-dots" aria-hidden="true">
        <span className="loading-dot">.</span>
        <span className="loading-dot">.</span>
        <span className="loading-dot">.</span>
      </span>
    </div>
  );
}
